'use client';

import { ContentOutageNotice } from '@/components/ContentOutageNotice';

/**
 * Segment boundary for the Mongo-backed blog pages.
 *
 * Without it these fell through to the root `app/error.tsx`, which is written
 * for a signed-in user hitting a bug — wrong copy, and a Contact Support link,
 * for an anonymous reader caught by a transient database outage (RELM-350).
 */
export default function BlogError({ reset }: { reset: () => void }) {
  return (
    <ContentOutageNotice
      what="article"
      indexHref="/blog"
      indexLabel="Browse all articles"
      reset={reset}
    />
  );
}
